export const settings = {
  selector: '.js-property-navigation',
  selectSelector: '.js-property-navigation-select',
  linksSelector: '.js-property-navigation-links'
}

/**
 * Initialize all elements in page.
 */
export default function initAll() {
  const nav = document.querySelector( settings.selector )
  if ( !nav ) {
    return
  }
  const navHeight = nav.offsetHeight

  let elements = document.querySelectorAll( settings.selectSelector )
  Array.from( elements ).forEach(( element ) => {
    element.addEventListener( 'change', function( e ) {
      scrollTo( e.target.value, navHeight )
    })
  })
  let links = document.querySelectorAll( settings.linksSelector )
  Array.from( links ).forEach(( element ) => {
    element.addEventListener( 'click', function( e ) {
      e.preventDefault()
      scrollTo( e.target.getAttribute( 'href' ), navHeight )
    })
  })
}

/**
 * Scroll to an element with given id.
 * @param string target
 */
function scrollTo( target, offset ) {
  const section = document.querySelector( target )
  if ( !section ) return

  const y = section.getBoundingClientRect().top + window.scrollY - offset
  window.scrollTo({ top: y, behavior: 'smooth' })
  history.pushState( null, '', target )
}
